import * as fetchDiscounts from 'store/actions/discounts/fetchDiscounts';
import * as createDiscounts from 'store/actions/discounts/createDiscounts';
import * as updateDiscounts from 'store/actions/discounts/updateDiscounts';
import * as deleteDiscounts from 'store/actions/discounts/deleteDiscounts';
import * as types from 'store/actions/types';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';
import utils from 'helpers/utils';

function* fetchDiscountsAsync({ payload }) {
    try {
        const url = `${ config.getApiBaseUrl() }/discounts`;

        const response = yield apiClient.read(url, payload);

        yield put(fetchDiscounts.fetchDiscountsSuccess(response));
    } catch (error) {
        yield put(fetchDiscounts.fetchDiscountsFailure(error));
    }
}

function* fetchDiscountAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/discounts/${ id }`;

        const response = yield apiClient.read(url);

        yield put(fetchDiscounts.fetchDiscountSuccess(response));

        if (utils.isFunction(onSuccess)) {
            yield onSuccess();
        }
    } catch (error) {
        yield put(fetchDiscounts.fetchDiscountFailure(error));

        if (utils.isFunction(onError)) {
            yield onError(error);
        }
    }
}

function* createDiscountAsync({ payload }) {
    const {
        onError,
        onSuccess,
        values,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/discounts`;

        const response = yield apiClient.create(url, values);

        yield put(createDiscounts.createDiscountSuccess(response));

        if (utils.isFunction(onSuccess)) {
            yield onSuccess();
        }
    } catch (error) {
        yield put(createDiscounts.createDiscountFailure(error));

        if (utils.isFunction(onError)) {
            yield onError(error);
        }
    }
}

function* createDiscountSuccessAsync() {
    yield put(showNotification('notifications.discounts.create.success'));
}

function* updateDiscountAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
        values,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/discounts/${ id }`;

        const response = yield apiClient.patch(url, values);

        yield put(updateDiscounts.updateDiscountSuccess(payload, response));

        if (utils.isFunction(onSuccess)) {
            yield onSuccess();
        }
    } catch (error) {
        yield put(updateDiscounts.updateDiscountFailure(error));

        if (utils.isFunction(onError)) {
            yield onError(error);
        }
    }
}

function* updateDiscountSuccessAsync() {
    yield put(showNotification('notifications.discounts.update.success'));
}

function* deleteDiscountAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/discounts/${ id }`;

        yield apiClient.delete(url);

        yield put(deleteDiscounts.deleteDiscountSuccess(payload));

        if (utils.isFunction(onSuccess)) {
            yield onSuccess();
        }
    } catch (error) {
        yield put(deleteDiscounts.deleteDiscountFailure(error));

        if (utils.isFunction(onError)) {
            yield onError(error);
        }
    }
}

function* deleteDiscountSuccessAsync() {
    yield put(showNotification('notifications.discounts.delete.success', 'success'));
}

function* failureMessage({ error }) {
    const { message } = error.response;

    if (!message) {
        return;
    }

    yield put(showNotification(message, 'warning'));
}

export default function* usersSagas() {
    yield [
        takeEvery(types.FETCH_DISCOUNTS, fetchDiscountsAsync),
        takeEvery(types.FETCH_DISCOUNTS_FAILURE, failureMessage),

        takeEvery(types.FETCH_DISCOUNT, fetchDiscountAsync),
        takeEvery(types.FETCH_DISCOUNT_FAILURE, failureMessage),

        takeEvery(types.CREATE_DISCOUNT, createDiscountAsync),
        takeEvery(types.CREATE_DISCOUNT_FAILURE, failureMessage),
        takeEvery(types.CREATE_DISCOUNT_SUCCESS, createDiscountSuccessAsync),

        takeEvery(types.UPDATE_DISCOUNT, updateDiscountAsync),
        takeEvery(types.UPDATE_DISCOUNT_FAILURE, failureMessage),
        takeEvery(types.UPDATE_DISCOUNT_SUCCESS, updateDiscountSuccessAsync),

        takeEvery(types.DELETE_DISCOUNT, deleteDiscountAsync),
        takeEvery(types.DELETE_DISCOUNT_FAILURE, failureMessage),
        takeEvery(types.DELETE_DISCOUNT_SUCCESS, deleteDiscountSuccessAsync),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/discountsSagas.js